module.exports = __webpack_public_path__ + "img/czleader9.ecc54f75.png";